import map from './parser-map';
import helpers from '../helpers';

const sportMap = map.sport;

class Sport {
  constructor(rawSport) {
    this.id = rawSport[sportMap.id];
    this.name = rawSport[sportMap.name];
    this.shortName = rawSport[sportMap.shortName] || this.name;
    this.position = parseInt(rawSport[sportMap.position], 10) || helpers.maxInt;
    this.providerId = parseInt(rawSport[sportMap.providerId], 10);
    this.numberOfMatches = parseInt(rawSport[sportMap.numberOfMatches], 10);
    this.active = true;
    this.showTournaments = false;
  }
}

export default Sport;
